import { render, staticRenderFns } from "./personalInfo.vue?vue&type=template&id=2243eb6c&scoped=true&"
import script from "./personalInfo.vue?vue&type=script&lang=js&"
export * from "./personalInfo.vue?vue&type=script&lang=js&"
import style0 from "./personalInfo.vue?vue&type=style&index=0&id=2243eb6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2243eb6c",
  null
  
)

export default component.exports